module.exports = __webpack_public_path__ + "37d8db2621c3aeecf690576321ddef16.jpg";